export default {
	en: {
		translation: {
			istock: {
				no_auth_title: "Upload files from your iStock by Getty Images account.",
				no_auth_action: "Connect to iStock",
				no_auth_statement: "iStock by Getty Images is one of the world's leading stock content marketplaces, offering millions of hand-picked premium images at ridiculously low prices that you can only get from us.",
				reg_link_text: "Click here to create an iStock by Getty Images account",
				select: "Select",
				search: {
					placeholder: "Search...",
					reset: "Reset search",
				},
				media_types: {
					images: "Images",
					videos: "Videos",
				},
				media_types_singular: {
					images: "image",
					videos: "video",
				},
				popular_categories: "Popular categories",
				diversity_categories: "Diversity categories",
				filters: {
					toggle_filters_button: "Filters",
					clear: "Clear",
					sort_options: {
						label: "Sort by",
						newest: "Newest",
						best_match: "Best match",
						most_popular: "Most popular",
						random: "Random",
					},
					orientation: {
						label: "Orientation",
						horizontal: "Horizontal",
						vertical: "Vertical",
						square: "Square",
						panoramic_horizontal: "Panoramic horizontal",
						panoramic_vertical: "Panoramic vertical",
					},
					number_of_people: {
						label: "Number of People",
						none: "None",
						one: "One",
						two: "Two",
						group: "Group",
					},
					license: {
						label: "License Type",
						creative: "Creative",
						editorial: "Editorial"
					},
					colors: {
						label: "Colors",
					},
					age_of_people: {
						label: "Age",
						baby: "Baby",
						child: "Child",
						teenager: "Teenager",
						young_adult: "Young adult",
						adult: "Adult",
						adults_only: "Adults only",
						mature_adult: "Mature adult",
						senior_adult: "Senior adult"
					},
					ethnicity: {
						label: "Ethnicity",
						black: "Black",
						caucasian: "Caucasian",
						east_asian: "East Asian",
						hispanic_latino: "Hispanic/LatinX",
						middle_eastern: "Middle Eastern",
						mixed_race_person: "Mixed Race Person",
						multiethnic_group: "Multi-Ethnic gGroup",
						native_american_first_nations: "Native American/First Nations",
						pacific_islander: "Pacific Islander",
						south_asian: "South Asian",
						southeast_asian: "Southeast Asian"
					},
					resolution: {
						label: "Resolution",
					},
					duration: {
						label: "Duration",
					},
					more: {
						label: "More",
						safe: "Safe (Exclude nudity)"
					},
					summary: {
						label: "Filters",
						color: "color: {{color}}",
						number_of_people: {
							none: "Without people",
							one: "With one person",
							two: "With two people",
							group: "With group people",

						}
					}
				},
				purchase: {
					select_plan: "Select Plan",
					select_format: "Select Format & Size",
					manage_plans: "Manage Plans",
					format: "Select Format & Size",
					credit: "Credit",
					credits: "Credits",
					istock_photo_id: "IStock photo ID",
					istock_video_id: "IStock video ID",
					plan_exceeded: "Plan Exceeded",
					size: {
						small: "Small",
						medium: "Medium",
						large: "Large",
						x_large: "X Large",
						xx_large: "XX Large",
						vector: "Vector"
					},
					credits_remaining: "credits remainings",
					media_type_not_included: "Your current plan does not include this {{mediaType}}",
					images: "images",
					videos: "videos",
					days_left: "days left",
					credits_balance_too_small: "Your credits balance is too small",
					collection: "Collection",
					cost: "Cost"
				},
				buttons: {
					next: "Next",
					upload: "Upload",
					purchase: "Purchase",
				}
			},
		},
	},
};
